export const amortizationTypes = {
  Mortgage_Style: "5ea9e68d-4680-11e9-82f6-0242ac120002",
  Straight_Line: "62d4a044- 4680 - 11e9 - 82f6-0242ac120002",
  Agency_Floater: "65a393e5-4680-11e9-82f6-0242ac120002",
  Interest_Only: "68b0cd1f-4680-11e9-82f6-0242ac120002",
  Straight_Line_Custom: "d358209d-4680-11e9-82f6-0242ac120002"
};
export const bizDayAdjustmentReset = {
  Unadjusted: "fd4f3dce-261c-11ec-a542-98fa9bde2f84",
  Following: "fd4f3e31-261c-11ec-a542-98fa9bde2f84",
  Preceding: "fd4f3ea9-261c-11ec-a542-98fa9bde2f84",
  Modified_Following: "fd4f3ebe-261c-11ec-a542-98fa9bde2f84",
  Modified_Preceding: "fd4f3ed3-261c-11ec-a542-98fa9bde2f84"
};
export const calculationAdjustment = {
  Following: "9ad1d853-7d75-11e9-9c8e-0242ac140002",
  Modified_Following: "9ad1d87c-7d75-11e9-9c8e-0242ac140002",
  Preceding: "9ad1d8a6-7d75-11e9-9c8e-0242ac140002",
  Modified_Preceding: "9ad1d8d2-7d75-11e9-9c8e-0242ac140002",
  Unadjusted: "9ad1d8ff-7d75-11e9-9c8e-0242ac140002"
};
export const currencyTypes = {
  USD: "fd4f3d99-261c-11ec-a542-98fa9bde2f84"
};
export const daycount = {
  Act_360: "fb692b8f-766e-11e9-87b9-0242ac120002",
  Act_365: "27c630c3-766f-11e9-87b9-0242ac120002",
  Thirty_360: "41a7e0bb-fd1e-42b4-8c50-c5e44dc81372",
  Act_Act: "6ed392ab-2f95-4186-a1ab-e3e4019051ed"
};
export const fixedIndices = {
  InternallyFixed: "2a7680cd-467f-11e9-82f6-0242ac120002",
  Treasurys: "a81385fa-467d-11e9-82f6-0242ac120002",
  SemiBond_Swaps: "ac46d8ac-467d-11e9-82f6-0242ac120002"
};
export const floatingIndices = {
  One_Month_LIBOR: "a11d7bd4-4681-11e9-82f6-0242ac120002",
  Three_Month_LIBOR: "b46abe9a-4681-11e9-82f6-0242ac120002",
  Six_Month_LIBOR: "bca352c6-4681-11e9-82f6-0242ac120002",
  Twelve_Month_LIBOR: "c6b1a7bb-4681-11e9-82f6-0242ac120002",
  Thirty_Day_Avg_SOFR: "d48732b4-6011-4ef5-8098-98691f75e7ec",
  SOFR: "d3d84f25-4681-11e9-82f6-0242ac120002",
  Prime: "ddab792e-4681-11e9-82f6-0242ac120002",
  Fed_Funds: "ea5cd592-4681-11e9-82f6-0242ac120002",
  SIFMA: "f2598911-4681-11e9-82f6-0242ac120002"
};
export const frequency = {
  Monthly: "bbd95d5d-4688-11e9-82f6-0242ac120002",
  Bi_Monthly: "bf12a607-4688-11e9-82f6-0242ac120002",
  Quarterly: "d019a5e2-4688-11e9-82f6-0242ac120002",
  Semi_Annually: "d41fb593-4688-11e9-82f6-0242ac120002",
  Annually: "d749ecb6-4688-11e9-82f6-0242ac120002",
  None: "eefe2b88-4688-11e9-82f6-0242ac120002"
};
export const instrumentTypes = {
  Loan: "fd4f3da3-261c-11ec-a542-98fa9bde2f84",
  Swap: "fd4f3e02-261c-11ec-a542-98fa9bde2f84",
  Cap: "fd4f3e91-261c-11ec-a542-98fa9bde2f84",
  Floor: "fd4f3eb3-261c-11ec-a542-98fa9bde2f84",
  Collar: "fd4f3ec8-261c-11ec-a542-98fa9bde2f84",
  Corridor: "fd4f3ede-261c-11ec-a542-98fa9bde2f84"
};
export const payOrReceive = {
  Receive: "fd4f3e11-261c-11ec-a542-98fa9bde2f84",
  Pay: "fd4f3dad-261c-11ec-a542-98fa9bde2f84"
};
export const paymentAdjustment = {
  Following: "9ad1d79e-7d75-11e9-9c8e-0242ac140002",
  Modified_Following: "9ad1d7bf-7d75-11e9-9c8e-0242ac140002",
  Preceding: "9ad1d7e3-7d75-11e9-9c8e-0242ac140002",
  Modified_Preceding: "9ad1d807-7d75-11e9-9c8e-0242ac140002"
};
export const rateTypes = {
  Floating: "fd4f3dc5-261c-11ec-a542-98fa9bde2f84",
  Fixed: "fd4f3e26-261c-11ec-a542-98fa9bde2f84"
};
export const resetDayTypes = {
  Fixed_Date: "fd4f3dd7-261c-11ec-a542-98fa9bde2f84",
  Adjusted_Date: "fd4f3e3d-261c-11ec-a542-98fa9bde2f84"
};
export const resetTypes = {
  Single_Reset: "fd4f3dec-261c-11ec-a542-98fa9bde2f84",
  Daily_Average: "fd4f3e53-261c-11ec-a542-98fa9bde2f84",
  Daily_Compounding: "fd4f3e9e-261c-11ec-a542-98fa9bde2f84"
};
export const rounding = {
  No_Rounding: "38f5d966-766c-11e9-87b9-0242ac120002",
  OneTenth: "c0059aaf-8897-11e9-93c5-00155ddd690a",
  OneHundreth: "1e2bd52a-766e-11e9-87b9-0242ac120002",
  OneThousandth: "2dc24865-766e-11e9-87b9-0242ac120002",
  OneTenThousandth: "3a62b842-766e-11e9-87b9-0242ac120002",
  OneEithgth: "4a92ede9-766e-11e9-87b9-0242ac120002",
  OneSixteenth: "5a08327b-766e-11e9-87b9-0242ac120002",
  OneThirtySecond: "663f1525-766e-11e9-87b9-0242ac120002",
  OneSixtyfourth: "765f2177-766e-11e9-87b9-0242ac120002"
};
export const roundingConventions = {
  Round_up: "2b5ff8a4-59d9-11ec-b9d7-98fa9bde2f84",
  Round_down: "2b5ff912-59d9-11ec-b9d7-98fa9bde2f84",
  Normal: "2b5ff91d-59d9-11ec-b9d7-98fa9bde2f84"
};
export const stubPeriodTypes = {
  Short_Stub: "fd4f3df6-261c-11ec-a542-98fa9bde2f84",
  Long_Stub: "fd4f3e5d-261c-11ec-a542-98fa9bde2f84"
};
export const whenPaymentOccurs = {
  Before_Calculation: "fd4f3db9-261c-11ec-a542-98fa9bde2f84",
  After_Calculation: "fd4f3e1b-261c-11ec-a542-98fa9bde2f84"
};
export const whenResetOccurs = {
  Before_Calculation: "fd4f3de0-261c-11ec-a542-98fa9bde2f84",
  After_Calculation: "fd4f3e49-261c-11ec-a542-98fa9bde2f84"
};
export const resetFrequency = {
  Daily: "0ab59aed-4cb0-11ec-b8fb-98fa9bde2f84",
  Weekly: "0ab59af3-4cb0-11ec-b8fb-98fa9bde2f84"
};
export const resetDay = {
  Monday: "0ab59b38-4cb0-11ec-b8fb-98fa9bde2f84",
  Tuesday: "0ab59afc-4cb0-11ec-b8fb-98fa9bde2f84",
  Wednesday: "0ab59b00-4cb0-11ec-b8fb-98fa9bde2f84",
  Thursday: "0ab59b03-4cb0-11ec-b8fb-98fa9bde2f84",
  Friday: "0ab59b07-4cb0-11ec-b8fb-98fa9bde2f84"
};
export const legTypes = {
  Pay: "48e0b1d1-5a64-11ec-b9d7-98fa9bde2f84",
  Receive: "48e0b1d7-5a64-11ec-b9d7-98fa9bde2f84"
};
export const cashflowTypes = {
  Loan: "7b7f48df-5a65-11ec-b9d7-98fa9bde2f84",
  Hedge: "7b7f48e5-5a65-11ec-b9d7-98fa9bde2f84"
};
export const hedgeTypes = {
  Floor: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408",
  Corridor: "addfa123-733b-11e9-b768-0242ac120002",
  Collar: "b73cb246-733b-11e9-b768-0242ac120002",
  Any_Lender_Approved: "cdefa777-733b-11e9-b768-0242ac120002",
  Cap: "fc0fa822-733b-11e9-b768-0242ac120002",
  Swap: "fe1fa999-733b-11e9-b768-0242ac120002"
};
